import React, { useRef } from 'react';
var VeltCommentsSidebarV2ResetFilterButton = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-comments-sidebar-reset-filter-button-v2", { ref: ref }, children));
};
export default VeltCommentsSidebarV2ResetFilterButton;
